// Geographic symbols share MapLibre's terrain projection and collision placement.
// Canvas annotations remain responsible for forecast values and static exports.
const SOURCE='forecast-localities',PEAKS='forecast-relief';
const NAME_IDS=['forecast-capital-names','forecast-town-names','forecast-locality-names','forecast-relief-names'];
const DOT='forecast-locality-dot';
const IDS=[...NAME_IDS];
export function localityDot(){
 const size=16,data=new Uint8Array(size*size*4);
 for(let y=0;y<size;y++)for(let x=0;x<size;x++){const r=Math.hypot(x-7.5,y-7.5),i=(y*size+x)*4;if(r>6)continue;const rgb=r>3.6?[255,255,255]:[20,45,67];data.set([...rgb,255],i);}
 return {width:size,height:size,data};
}
export function placeFeatures(places){
 return {type:'FeatureCollection',features:places.filter(p=>p.name&&Number.isFinite(p.lon)&&Number.isFinite(p.lat)).map(p=>({type:'Feature',geometry:{type:'Point',coordinates:[p.lon,p.lat]},properties:{name:p.name,priority:p.rank??(p.position_source==='WSLAMLocation'?5:2),detail:p.position_source==='WSLAMLocation',terrainOnly:p.type==='Mountain'}}))};
}
export class GeographicLabels {
 constructor(map,{peaksUrl='relief-peaks.json?v=20260930'}={}){this.map=map;this.places=null;this.peaksPromise=null;this.peaksUrl=peaksUrl;}
 setPlaces(places){
  if(this.places===places)return;this.places=places;
  const data=placeFeatures(places);
  if(this.map.getSource(SOURCE))this.map.getSource(SOURCE).setData(data);
  else this.map.addSource(SOURCE,{type:'geojson',data,attribution:'Località: Weather Sicily / WSLAM'});
  if(!this.map.getSource(PEAKS))this.map.addSource(PEAKS,{type:'geojson',data:{type:'FeatureCollection',features:[]},attribution:'Rilievi: © OpenStreetMap contributors · ODbL'});
  if(this.map.getLayer(NAME_IDS[0]))return;
  const layout={'text-field':['get','name'],'text-font':['Noto Sans Regular'],'text-size':12,'text-padding':14,'text-anchor':'bottom','text-offset':[0,-.5],'text-pitch-alignment':'viewport','text-rotation-alignment':'viewport','symbol-sort-key':['get','priority'],visibility:'none'};
  const paint={'text-color':'#142d43','text-halo-color':'#fff','text-halo-width':2};
  if(!this.map.hasImage(DOT))this.map.addImage(DOT,localityDot(),{pixelRatio:2});
  const anchored={...layout,'icon-image':DOT,'icon-optional':false,'text-optional':false,'icon-pitch-alignment':'viewport'};
  this.map.addLayer({id:NAME_IDS[0],type:'symbol',source:SOURCE,filter:['<=',['get','priority'],0],layout:anchored,paint});
  this.map.addLayer({id:NAME_IDS[1],type:'symbol',source:SOURCE,minzoom:8,filter:['all',['>',['get','priority'],0],['!=',['get','detail'],true]],layout:anchored,paint});
  this.map.addLayer({id:NAME_IDS[2],type:'symbol',source:SOURCE,minzoom:11,filter:['all',['==',['get','detail'],true],['!=',['get','terrainOnly'],true]],layout:anchored,paint});
  this.map.addLayer({id:NAME_IDS[3],type:'symbol',source:PEAKS,minzoom:10,layout:{...layout,'text-field':['concat','△ ',['get','name']],'text-size':11,'text-padding':18},paint:{...paint,'text-color':'#384830'}});
 }
 loadPeaks(){
  if(!this.peaksPromise)this.peaksPromise=fetch(this.peaksUrl).then(r=>{if(!r.ok)throw Error('Rilievi non disponibili');return r.json();}).then(data=>{
   this.map.getSource(PEAKS)?.setData(placeFeatures(data.peaks));
  }).catch(error=>{this.peaksPromise=null;console.warn('Rilievi:',error.message);});
  return this.peaksPromise;
 }
 update({enabled,terrain=false}){
  if(!this.map.getLayer(NAME_IDS[0]))return;
  if(this.terrain!==terrain){
   this.terrain=terrain;
   const filter=['all',['==',['get','detail'],true],...(terrain?[]:[['!=',['get','terrainOnly'],true]])];
   this.map.setFilter(NAME_IDS[2],filter);
  }
  for(const id of IDS){
   const visibility=enabled&&(id!==NAME_IDS[3]||terrain)?'visible':'none';
   if(this.map.getLayoutProperty(id,'visibility')!==visibility)this.map.setLayoutProperty(id,'visibility',visibility);
  }
  // New weather/observation layers must never cover geographic names.
  const layers=this.map.getStyle().layers,lastSurface=layers.reduce((last,l,i)=>['raster','hillshade','custom','fill','line'].includes(l.type)?i:last,-1);
  if(IDS.some(id=>layers.findIndex(l=>l.id===id)<lastSurface))for(const id of IDS)this.map.moveLayer(id);
  if(enabled&&terrain)this.loadPeaks();
 }
 reservations(){
  if(!this.map.getLayer(NAME_IDS[0]))return [];
  return this.map.queryRenderedFeatures({layers:NAME_IDS}).map(f=>({point:this.map.project(f.geometry.coordinates),width:Math.min(110,f.properties.name.length*3.5+14)}));
 }
}
